import React from "react"
import Link from "gatsby-link"
import SEO from '../components/SEO'
import SVGInline from 'react-svg-inline'


class Page extends React.Component {
    constructor() {
        super();
        // this.handleSubmit = this.handleSubmit.bind(this);
    }

    // handleSubmit(e) {
    //     e.preventDefault();
    //
    //     const formData = {};
    //     for (const field in this.refs) {
    //         if(this.refs[field].checked) {
    //             formData[field] = this.refs[field].checked;
    //         } else {
    //             formData[field] = this.refs[field].value;
    //         }
    //     }
    //
    //     let toSend = {
    //         _replyto: formData._replyto,
    //         'Informatii Asociatie':
    //         'Nume asociatie: ' + formData.numeAsociatie + '\n' +
    //         'Adresa asociatie: ' + formData.adresaAsociatie + '\n' +
    //         'Incalzire bloc: ' + formData.incalzireBloc + '\n' +
    //         'An constructie bloc: ' + formData.anConstructieBloc + '\n' +
    //         'Numar de apartament: ' + formData.numarDeApartamente + '\n' +
    //         'Numar de scari: ' + formData.numarDeScari + '\n',
    //         'Date de contact':
    //         'Nume persoane de contact: ' + formData.numePersoanaDeContact + '\n' +
    //         'Functie persoana de contact: ' + formData.functiePersoanaDeContact + '\n' +
    //         'Telefon persoana de contact: ' + formData.telefonPersoanaDeContact + '\n' +
    //         'Adresa de email: ' + formData._replyto + '\n',
    //         'Servicii oferite':
    //              (formData.administrareFinanciara == true ? 'Administrare financiara \n' : '') +
    //              (formData.casierie == true ? 'Casierie \n' : '') +
    //              (formData.administrareTehnica == true ? 'Administrare Tehnica \n' : '') +
    //              (formData.managementDeProiect == true ? 'Management De Proiect \n' : '') +
    //              (formData.cenzorat == true ? 'Cenzorat \n' : '')
    //     };
    //
    //
    //     const request = require('superagent');
    //     request.post("https://formspree.io/nicad.imob@gmail.com")
    //         .set('Content-type', 'application/json')
    //         .set('Accept', 'application/json')
    //         .send(toSend)
    //         .end(() => {
    //             document.getElementById("priceForm").reset();
    //         });
    // }

    render() {
        const pageSEO = {
            title: "Pret administrare imobile Bucuresti",
            description: "Primeste o oferta de pret personalizata pentru administrarea imobilului tau. Prețurile noastre se calculeaza functie de pachetul ales si de numarul de apartamente.",
            path: "/servicii/asistenta-ssm-si-psi/"
        };

        let options = [
            {value: 'one', label: 'One'},
            {value: 'two', label: 'Two'},
            {value: 'two', label: 'Three'},
            {value: 'two', label: 'Four'},
            {value: 'two', label: 'Five'}
        ];

        return (
            <div className="o-page__content">
                <SEO pageSEO={pageSEO}/>
                <div className="c-section-gradient">
                    <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
                        <h1 className="c-page__heading">Preturi administrare imobile Bucuresti</h1>
                    </div>
                </div>

                <div className="o-container u-pv-20 u-pv-30@tablet u-bg-white">
                    <div className="o-container o-container--text u-ph-0 u-text-center">

                        <p>Prețurile noastre se calculeaza functie de pachetul ales si de numarul de apartamente.</p>
                        <p>Îți poți genera o ofertă pentru administrarea imobilului tău completand formularul de mai
                            jos.</p>
                    </div>
                </div>

                <div className="o-container o-container--offer">
                    <div className="o-container o-container--large u-ph-0">
                        <div className="c-offer">
                            <h2 className="c-offer-title">Genereaza o oferta personaliata</h2>


                            <form action="https://formspree.io/nicad.imob@gmail.com"
                                  method="POST"
                                  id="priceForm">
                                <div className="o-layout o-layout--gutter-10 c-offer-layout">
                                    <div className="o-layout__item o-layout__item--auto-size p-prices__item-1">

                                        <div className="c-box">
                                            <h3 className="c-box__title">Informatii asociatie</h3>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="numeAsociatie">Nume asociație</label>
                                                <input className="c-input" type="text" name="numeAsociatie" ref="numeAsociatie" required/>
                                            </div>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="adresaAsociatie">Adresa asociație</label>
                                                <input className="c-input" type="text" name="adresaAsociatie" ref="adresaAsociatie" required/>
                                            </div>
                                            <div className="u-mb-05">
                                                <div className="o-layout o-layout--gutter-10">
                                                    <div className="o-layout__item u-1/1 u-1/2@tablet">
                                                        <div className="c-form__field u-mb-0">
                                                            <label className="c-label" htmlFor="incalzireBloc">Incalzire bloc</label>
                                                            <select className="c-input c-select u-1/1" name="incalzireBloc" ref="incalzireBloc" required>
                                                                <option value="RADET">RADET</option>
                                                                <option value="Centrala de bloc">Centrala de bloc
                                                                </option>
                                                                <option value="Centrale de apartament">Centrale de
                                                                    aparatament
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="o-layout__item u-1/1 u-1/2@tablet">
                                                        <div className="c-form__field u-mb-0">
                                                            <label className="c-label" htmlFor="anConstructieBloc">An constructie
                                                                bloc</label>
                                                            <input className="c-input" type="number" name="anConstructieBloc" ref="anConstructieBloc" required/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="o-layout o-layout--gutter-10">
                                                <div className="o-layout__item u-1/1 u-1/2@tablet">
                                                    <div className="c-form__field">
                                                        <label className="c-label" htmlFor="numarDeApartamente">Număr de
                                                            apartamente</label>
                                                        <input className="c-input" type="number" name="numarDeApartamente" ref="numarDeApartamente" required/>
                                                    </div>
                                                </div>
                                                <div className="o-layout__item u-1/1 u-1/2@tablet">
                                                    <div className="c-form__field">
                                                        <label className="c-label" htmlFor="numarDeScari">Număr de scari</label>
                                                        <input className="c-input" type="number" name="numarDeScari" ref="numarDeScari" required/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="o-layout__item o-layout__item--auto-size p-prices__item-2">

                                        <div className="c-box">
                                            <h3 className="c-box__title">Date de contact</h3>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="numePersoanaDeContact">Nume persoană de contact</label>
                                                <input className="c-input" type="text" name="numePersoanaDeContact" ref="numePersoanaDeContact" required/>
                                            </div>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="functiePersoanaDeContact">Funcție persoană de
                                                    contact</label>
                                                <input className="c-input" type="text" name="functiePersoanaDeContact" ref="functiePersoanaDeContact" required/>
                                            </div>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="telefonPersoanaDeContact">Telefon persoană de
                                                    contact</label>
                                                <input className="c-input" type="text" name="telefonPersoanaDeContact" ref="telefonPersoanaDeContact" required/>
                                            </div>
                                            <div className="c-form__field">
                                                <label className="c-label" htmlFor="_replyto">Adresa de email la care va fi
                                                    trimisă oferta</label>
                                                <input className="c-input" type="email" name="_replyto" ref="_replyto" required/>
                                            </div>
                                        </div>

                                    </div>
                                    <div
                                        className="o-layout__item o-layout__item--auto-size c-price__last p-prices__item-3">
                                        <div className="c-box c-price__last-box">
                                            <h3 className="c-box__title">Servicii dorite</h3>
                                            <div className="c-price__last-check">
                                                <div className="c-checkbox u-mb-10">
                                                    <input type="checkbox" id="administrareFinanciara"
                                                           name="administrareFinanciara" ref="administrareFinanciara"/>
                                                    <label htmlFor="administrareFinanciara">Administrare
                                                        financiară</label>
                                                </div>
                                                <div className="c-checkbox u-mb-10">
                                                    <input type="checkbox" id="casierie" name="Casierie" ref="casierie"/>
                                                    <label htmlFor="casierie">Plata numerar</label>
                                                </div>
                                                <div className="c-checkbox u-mb-10">
                                                    <input type="checkbox" id="administrareTehnica"
                                                           name="Administrare tehnică" ref="administrareTehnica"/>
                                                    <label htmlFor="administrareTehnica">Administrare tehnică</label>
                                                </div>
                                                <div className="c-checkbox u-mb-10">
                                                    <input type="checkbox" id="managementDeProiect"
                                                           name="Management de proiect" ref="managementDeProiect"/>
                                                    <label htmlFor="managementDeProiect">Management de proiect</label>
                                                </div>
                                                <div className="c-checkbox u-mb-0">
                                                    <input type="checkbox" id="cenzorat" name="Cenzorat" ref="cenzorat"/>
                                                    <label htmlFor="cenzorat">Cenzorat</label>
                                                </div>
                                            </div>
                                        </div>

                                        <input type="text" name="_gotcha" style={{display: 'none'}} />

                                        <input type="submit" className="c-button u-mt-10" value="Vreau oferta"/>

                                    </div>

                                </div>


                            </form>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}

export default Page




// WEBPACK FOOTER //
// ./src/pages/preturi.js